import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { appConfirm } from "@/components/AppDialogHost";

const inputCls = "w-full rounded-md border border-line bg-bg px-3 py-2 text-sm text-ink-primary placeholder:text-ink-muted focus:outline-none focus:border-brand-amber/60";

export default function AdminCannedTab() {
  const [canned, setCanned] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/helpdesk/canned").then((r) => setCanned(r.data.canned)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!editing.title.trim() || !editing.body.trim()) { toast.error("Title and body required"); return; }
    try {
      if (editing.canned_id) await api.patch(`/admin/helpdesk/canned/${editing.canned_id}`, editing);
      else await api.post("/admin/helpdesk/canned", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };
  const del = async (c) => {
    if (!await appConfirm(`Delete "${c.title}"?`)) return;
    await api.delete(`/admin/helpdesk/canned/${c.canned_id}`); load();
  };

  return (
    <div className="space-y-3 max-w-3xl" data-testid="admin-canned-tab">
      <p className="text-[11px] text-ink-muted">Templates support {"{first_name}"} which fills with the customer's first name when inserted. Agents can always edit before sending.</p>
      {editing ? (
        <div className="rounded-xl border border-line bg-bg-surface p-4 space-y-2">
          <input className={inputCls} value={editing.title} placeholder="Template title" data-testid="canned-title-input"
            onChange={(e) => setEditing({ ...editing, title: e.target.value })} />
          <textarea className={`${inputCls} min-h-[160px]`} value={editing.body} placeholder="Template body…" data-testid="canned-body-input"
            onChange={(e) => setEditing({ ...editing, body: e.target.value })} />
          <div className="flex gap-2">
            <button type="button" onClick={save} data-testid="canned-save-btn"
              className="rounded-md bg-brand-amber px-4 py-2 text-xs font-semibold text-black">Save template</button>
            <button type="button" onClick={() => setEditing(null)} className="text-xs text-ink-muted hover:text-ink-primary">Cancel</button>
          </div>
        </div>
      ) : (
        <button type="button" onClick={() => setEditing({ title: "", body: "" })} data-testid="canned-new-btn"
          className="inline-flex items-center gap-1.5 rounded-md bg-brand-amber px-3.5 py-2 text-xs font-semibold text-black">
          <Plus className="h-3.5 w-3.5" /> New template
        </button>
      )}
      <div className="space-y-1.5">
        {canned.map((c) => (
          <div key={c.canned_id} className="flex items-start gap-3 rounded-lg border border-line bg-bg-surface px-4 py-3"
            data-testid={`canned-row-${c.canned_id}`}>
            <div className="min-w-0 flex-1">
              <div className="text-sm text-ink-primary">{c.title}</div>
              <div className="text-[11px] text-ink-muted line-clamp-2 whitespace-pre-wrap">{c.body}</div>
            </div>
            <button type="button" onClick={() => setEditing(c)} className="text-ink-muted hover:text-brand-amber mt-1"><Pencil className="h-3.5 w-3.5" /></button>
            <button type="button" onClick={() => del(c)} className="text-ink-muted hover:text-rose-300 mt-1"><Trash2 className="h-3.5 w-3.5" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
